import CategoryView from "src/organisms/CategoryView";
import { buildStaticProps } from "src/utils/static-props/app-page-props";

export default function ProductCategorieIndex(): JSX.Element {
  return <CategoryView />;
}

export function getStaticPaths() {
  return { paths: [], fallback: "blocking" as const };
}

export async function getStaticProps() {
  return buildStaticProps({});
}
